import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DescriptorFormControl } from '../../descriptor/descriptor-form-control';
import { ControlType } from '../../enum/control-types';
import { LovService } from '../../services/lov.service';

@Component({
  selector: 'vedrax-title',
  template: '{{title}}'
})
export class VedraxTitleComponent implements OnInit, OnDestroy {

  private subscription: Subscription = new Subscription();

  @Input() descriptor: DescriptorFormControl = new DescriptorFormControl();
  @Input() index: number = 0;

  title: string = '';

  constructor(private lovService: LovService) { }

  ngOnInit(): void {
    this.constructTitle();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Method for returning a title
   * @returns 
   */
  private constructTitle(): void {

    const keys = this.descriptor.controlKeysAsTitle || [];

    this.title = '';

    keys.forEach(key => {
      const ctrl = this.getControlFromKey(key);

      if (ctrl && ctrl.controlType === ControlType.input) {
        this.title = `${this.title} ${this.getValue(key)}`;
      }

      if (ctrl && ctrl.controlType === ControlType.select) {
        this.initElementWithSelectedOption(ctrl, this.getValue(key));
      }

    });

  }

  /**
   * Method for getting a control by its key
   * @param key 
   * @returns 
   */
  private getControlFromKey(key: string = ''): DescriptorFormControl {
    const children = this.descriptor.controlChildren || [];
    return children.filter(child => child.controlName === key)[0];
  }

  /**
   * Helper method for getting an option
   * @param ctrl 
   * @param key 
   * @returns 
   */
  private initElementWithSelectedOption(ctrl: DescriptorFormControl, key: any): void {

    if (ctrl.endpointForOptions) {

      this.subscription.add(this.lovService.getOption(ctrl.endpointForOptions, key)
        .subscribe(option => {
          if (option) {
            this.title = `${this.title} ${option.value}`;
          }
        }));

    } else {

      const options = ctrl.controlOptions || [];
      const option = options.filter(option => option.key === key)[0];

      if (option) {
        this.title = `${this.title} ${option.value}`;
      }

    }

  }

  private getValue(key: string = ''): string {
    const values = this.descriptor.controlValue || [];
    const item = values[this.index] || {};
    return item[key] || '';
  }

}
